export default __webpack_public_path__ + "static/media/detail_small_4_5.4ec86fca.png";